import React from 'react';
import Icon from '../../../components/AppIcon';

const LeaveBalanceCard = ({ leaveType, accruedDays, usedDays, balanceDays }) => {
  const leaveTypeConfig = {
    annual: {
      label: 'Annual Leave',
      icon: 'Calendar',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    sick: {
      label: 'Sick Leave',
      icon: 'Heart',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    maternity: {
      label: 'Maternity Leave',
      icon: 'Baby',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    long_service: {
      label: 'Long Service Leave',
      icon: 'Award',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  };

  const config = leaveTypeConfig?.[leaveType] || leaveTypeConfig?.annual;
  const usagePercentage = accruedDays > 0 ? (usedDays / accruedDays) * 100 : 0;

  return (
    <div className="bg-card border border-border rounded-lg p-5 hover:shadow-md transition-smooth">
      <div className="flex items-center gap-3 mb-4">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${config?.bgColor}`}>
          <Icon name={config?.icon} size={20} className={config?.color} />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-foreground">{config?.label}</h4>
          <p className="text-xs text-muted-foreground">Current Year Balance</p>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Available</span>
          <span className="text-2xl font-bold text-foreground">{balanceDays || 0} days</span>
        </div>

        <div className="w-full bg-muted rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all ${config?.bgColor}`}
            style={{ width: `${Math.min(usagePercentage, 100)}%` }}
          />
        </div>

        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Used: {usedDays || 0} days</span>
          <span>Accrued: {accruedDays || 0} days</span>
        </div>
      </div>
    </div>
  );
};

export default LeaveBalanceCard;
